module.exports = __webpack_public_path__ + "static/img_1959-09754c31e97016d69567ffe7cfe0b8f6.webp";